import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { UsersComponent } from './users/users.component';
import { TarifsComponent } from './tarifs/tarifs.component';
import { ListsComponent } from './lists/lists.component';
import { TypePrestationsComponent } from './type-prestations/type-prestations.component';
import { TypeExpertisesComponent } from './type-expertises/type-expertises.component';

const routes: Routes = [
	{ path: 'a',  component: AdminComponent , children: [
		{ path: 'tarifs',  component: TarifsComponent },
		{ path: 'lists',  component: ListsComponent },
		{ path: 'prestations',  component: TypePrestationsComponent },
		{ path: 'expertises',  component: TypeExpertisesComponent },
	]},
	{ path: '**', redirectTo: 'a/prestations', pathMatch: 'full' }
	
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
